export default __webpack_public_path__ + "static/media/HeroBanner.e00bd8ba.png";